import { render } from "./sidebar-signposts.vue?vue&type=template&id=886010d2"
import script from "./sidebar-signposts.vue?vue&type=script&lang=js"
export * from "./sidebar-signposts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__